/*
 * Order States
 *
 * open
 * This means that the order has been opened and that you can add item to it. Pickers are not yet notified of the order.
 *
 * confirmed
 * When the customer is done adding items and placed the order. This is when pickers are getting notified.
 *
 * assigned-to-picker
 * When the picker is accepted.
 *
 * picked-up
 * When the picker has confirmed the purchase and the order has been picked up.
 * An order can move to the picked-up state only if all of its order items are not in the "todo" state (see below for more details), and the "paid_price" or the "receipt_id" data in the order has been provided.
 *
 * delivered
 * The delivered state means that the customer has accepted the order from the picker.
 *
 * aborted
 * Either when the customer cancels an open order, or when there is a timeout because a picker has not been found.
 *
 * cancelled
 * When the support cancelled an order.
 *
 * @link http://order-api.test-migros.ch/doc/
 */
export const OPEN = 'open';
export const CONFIRMED = 'confirmed';
export const ASSIGNED_TO_PICKER = 'assigned-to-picker';
export const PICKED_UP = 'picked-up';
export const DELIVERED = 'delivered';
export const ABORTED = 'aborted';
export const CANCELLED = 'cancelled';

export const SUCCESS_MODAL_CASES = [ASSIGNED_TO_PICKER, PICKED_UP, DELIVERED];
export const ERROR_MODAL_CASES = [ABORTED, CANCELLED];



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/order-states.js